import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "../../forms/Label";
import Select, { TSelectOption } from "@/components/forms/Select/Select";

type TAgentFilter = {
  onScoreSel: (value: number | null) => void;
  selVal?: number | null;
};

const ScoreDropdown = ({ onScoreSel, selVal }: TAgentFilter) => {
  const { t } = useTranslation("common");

  const scoreRangeList = useMemo(
    () => [
      { label: "< 10%", value: "10" },
      { label: "< 20%", value: "20" },
      { label: "< 30%", value: "30" },
      { label: "< 40%", value: "40" },
      { label: "< 50%", value: "50" },
      { label: "< 60%", value: "60" },
      { label: "< 70%", value: "70" },
      { label: "< 80%", value: "80" },
      { label: "< 90%", value: "90" },
      { label: "< 100%", value: "100" },
    ],
    [],
  );

  // Agent change event
  const handleScoreClick = (item: TSelectOption) => {
    onScoreSel(Number(item.value));
  };

  // Find the selected option from the list
  const selectedOption = useMemo(() => {
    if (!selVal) return null;
    return (
      scoreRangeList?.find((item) => Number(item.value) === selVal) ?? null
    );
  }, [scoreRangeList, selVal]);

  return (
    <>
      {scoreRangeList && (
        <div className="">
          <Label weight={"medium"}>{t("FILTER.SCORE")}</Label>
          <Select
            name="score"
            options={scoreRangeList}
            value={selectedOption}
            onChange={(option: TSelectOption) => handleScoreClick(option)}
            getOptionLabel={(option: TSelectOption) => option.label}
            getOptionValue={(option: TSelectOption) => option.value}
            placeholder={t("FILTER.SELECT_SCORE")}
            className="text-sm"
            isClearable={false}
          />
        </div>
      )}
    </>
  );
};
export default ScoreDropdown;
